import React, { useState } from 'react';
import './MessagePage.css';

const MOCK_MESSAGES = [
  { id: 1, type: 'system', title: '系统通知', content: '欢迎加入AI音乐共创社区！', time: '刚刚', unread: true, icon: 'fa-bell', color: '#667eea' },
  { id: 2, type: 'like', user: '音乐狂人', content: '赞了你的作品《午夜爵士》', time: '5分钟前', unread: true, avatar: '音', cover: '#FFD93D' },
  { id: 3, type: 'comment', user: 'Alice', content: '评论: "这种风格太棒了！"', time: '1小时前', unread: false, avatar: 'A', cover: '#FF6B6B' },
  { id: 4, type: 'like', user: 'BeatMaker', content: '赞了你的作品《赛博朋克2077》', time: '2小时前', unread: false, avatar: 'B', cover: '#4ECDC4' },
  { id: 5, type: 'system', title: '版本更新', content: '魔法改编功能已上线，快来试试吧！', time: '1天前', unread: false, icon: 'fa-wrench', color: '#764ba2' },
  { id: 6, type: 'comment', user: 'GuitarHero', content: '回复: "确实，吉他部分很真实"', time: '2天前', unread: false, avatar: 'G', cover: '#AA96DA' },
];

function MessagePage() {
  const [activeFilter, setActiveFilter] = useState('all');

  return (
    <div className="message-page">
      <div className="message-header">
        <h2>消息中心</h2>
        <div className="message-filters">
          <button 
            className={`filter-btn ${activeFilter === 'all' ? 'active' : ''}`}
            onClick={() => setActiveFilter('all')}
          >全部</button>
          <button 
            className={`filter-btn ${activeFilter === 'unread' ? 'active' : ''}`}
            onClick={() => setActiveFilter('unread')}
          >未读</button>
        </div>
      </div>

      <div className="message-list h-scrollable">
        {MOCK_MESSAGES.map(msg => (
          <div key={msg.id} className={`message-item ${msg.unread ? 'unread' : ''}`}>
            
            {/* 左侧图标/头像 */}
            <div className="message-left">
              {msg.type === 'system' ? (
                <div className="system-icon" style={{ background: msg.color }}>
                  <i className={`fas ${msg.icon}`}></i>
                </div>
              ) : (
                <div className="user-avatar">{msg.avatar}</div>
              )}
            </div>

            {/* 中间内容 */}
            <div className="message-content">
              <div className="message-title-row">
                <span className="message-title">
                  {msg.type === 'system' ? msg.title : msg.user}
                </span>
                <span className="message-time">{msg.time}</span>
              </div>
              <p className="message-text">{msg.content}</p>
            </div>

            {/* 右侧（作品封面或小红点） */}
            <div className="message-right">
              {msg.unread && <div className="red-dot"></div>}
              {msg.cover && (
                <div className="msg-cover" style={{ background: msg.cover }}>
                  <i className="fas fa-music"></i>
                </div>
              )}
            </div>
          </div>
        ))}
        {/* 底部留白 */}
        <div style={{ height: 80 }}></div>
      </div>
    </div>
  );
}

export default MessagePage;